module.exports = __webpack_public_path__ + "Roboto-Thin.dfe56a876d0282555d1e.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Thin.eot
// module id = ../../../../../src/font/roboto/Roboto-Thin.eot
// module chunks = 1